import { render, staticRenderFns } from "./CancelNewJobBtn.vue?vue&type=template&id=475b4003&scoped=true&"
import script from "./CancelNewJobBtn.vue?vue&type=script&lang=js&"
export * from "./CancelNewJobBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b4003",
  null
  
)

export default component.exports